
const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    speed: 800
};

export const prevArrow = `
    <button aria-label="Previous slide" class="card-slider__prev button solid">
        <svg class="prev" xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" style="transform:rotate(-180deg)">
            <g fill="currentColor">
                <path d="M39.541 28.98h-23.787v-3.235h23.788Z"/>
                <path d="m32.003 37.178 -2.287 -2.287 7.539 -7.539 -7.539 -7.539 2.287 -2.288 9.827 9.826Z"/>
            </g>
        </svg>
    </button>`;
export const nextArrow = `
    <button aria-label="Next slide" class="card-slider__next button solid">
        <svg class="next" xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55">
            <g fill="currentColor">
                <path d="M39.542 28.98H15.753v-3.235h23.788Z"/>
                <path d="m32.003 37.178 -2.287 -2.287 7.538 -7.538 -7.538 -7.538 2.287 -2.288 9.826 9.826Z"/>
            </g>
        </svg>
    </button>`;


jQuery( function( $ ) {
    document.querySelectorAll( '.card-slider--small' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 5,

            nextArrow,
            prevArrow,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        autoplay: true,
                        autoplaySpeed: 3000,
                        slidesToShow: 2,
                        infinite: true,
                        arrows: false
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        autoplay: true,
                        autoplaySpeed: 3000,
                        infinite: true,
                        arrows: false
                    }
                }
            ],
        } );
    } );
} );

jQuery( function( $ ) {
    document.querySelectorAll( '.card-slider--medium' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 3,
            nextArrow,
            prevArrow,
            responsive: [
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ],
        } );
    } );
} );

jQuery( function( $ ) {
    document.querySelectorAll( '.card-slider--large' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 2 + 1 / 3,
            nextArrow,
            prevArrow,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 4 / 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ],
        } );
    } );
} );

jQuery( function( $ ) {
    document.querySelectorAll( '.card-slider--huge' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 1,
            nextArrow,
            prevArrow,
        } );
    } );
} );